import { ArrowRight, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function HeroHome() {
  return <section data-section-id="REEMPLAZAR" id="hero" className="bg-background text-foreground relative min-h-[90vh] flex items-center overflow-hidden py-20 lg:py-32">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,hsl(var(--primary)/0.05)_0%,transparent_70%)] pointer-events-none" />
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          <div className="flex flex-col items-start text-left order-2 lg:order-1">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-primary/10 border border-primary/20 mb-6">
              <ShieldCheck className="size-4 text-primary" />
              <span className="text-xs font-mono uppercase tracking-wider text-primary">
                Plataforma PLD para sujetos obligados de LFPIORPI
              </span>
            </div>
            <h1 className="font-default text-5xl sm:text-6xl lg:text-[80px] leading-[1.05] font-extrabold text-foreground tracking-tighter">
              Cumple con la LFPIORPI sin complicaciones
            </h1>
            <p className="mt-6 text-lg sm:text-xl text-muted-foreground max-w-xl font-default leading-relaxed">
              Notalia automatiza KYC, screening PEP/OFAC y generación de expedientes para cualquier giro sujeto a la ley: notarías, joyerías, inmobiliarias, brokers, desarrolladoras, blindadoras, agentes aduanales, mediadores y más. Un solo sistema, 17 actividades vulnerables distintas.
            </p>
            <div className="mt-10 flex flex-col items-start gap-3">
              <Link to="https://panel.notalia.app/">
                <Button size="lg" className="px-8 h-14 text-lg font-semibold bg-primary hover:bg-primary/90 text-primary-foreground transition-all duration-200">
                  Empieza gratis
                  <ArrowRight className="ml-2 size-5" />
                </Button>
              </Link>
              <p className="text-xs text-muted-foreground font-mono">
                14 días de Pro completo sin tarjeta. Cancela cuando quieras.
              </p>
            </div>
          </div>
          <div className="relative w-full max-w-lg mx-auto lg:ml-auto flex justify-center items-center order-1 lg:order-2">
            <div className="absolute inset-0 bg-primary/20 blur-[120px] rounded-lg transform scale-90" />
            <div className="relative z-10 w-full aspect-square flex items-center justify-center">
              <div className="w-full h-full relative">
                <div className="absolute inset-8 rounded-2xl bg-gradient-to-br from-primary/30 to-primary/5 border border-primary/20" />
                <div className="absolute inset-16 rounded-xl bg-card border border-border flex items-center justify-center">
                  <ShieldCheck className="size-32 text-primary/80" strokeWidth={1.2} />
                </div>
                <div className="absolute top-0 left-0 w-8 h-8 border-t border-l border-primary/40 rounded-tl-md" />
                <div className="absolute top-0 right-0 w-8 h-8 border-t border-r border-primary/40 rounded-tr-md" />
                <div className="absolute bottom-0 left-0 w-8 h-8 border-b border-l border-primary/40 rounded-bl-md" />
                <div className="absolute bottom-0 right-0 w-8 h-8 border-b border-r border-primary/40 rounded-br-md" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}